'use client';

import cn from '@sindresorhus/class-names';
import {escapeForJsContext} from '@utils/stringEscape';
import {useMemo} from 'react';
import {BreadcrumbList, ListItem, WithContext} from 'schema-dts';

import styles from './Breadcrumbs.module.scss';
import {BreadcrumbsItem} from './BreadcrumbsItem';
import {BreadcrumbsProps} from './types';

/**
 * рисует цепочку ссылок потипу:
 *
 * Главная > Чуть менее главная > Еще какая-то страница
 */
export const Breadcrumbs = ({
  backstack,
  className,
  lastItemDisplayMode,
  domainForJsonLd,
  onItemClick,
}: BreadcrumbsProps) => {
  const jsonLdData = useMemo(() => {
    const data: WithContext<BreadcrumbList> = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: backstack.map(
        ({path, title}, index): ListItem => ({
          '@type': 'ListItem',
          item: {
            '@id': path.startsWith('https://')
              ? path
              : `${domainForJsonLd}${path === '/' ? '' : path}`,
            name: escapeForJsContext(title),
          },
          position: index,
        }),
      ),
    };

    return JSON.stringify(data);
  }, [backstack, domainForJsonLd]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{__html: jsonLdData}}
      />
      <ul
        itemScope
        itemType="https://schema.org/BreadcrumbList"
        className={cn(styles.list, className)}
        aria-label="Навигация"
      >
        {backstack.map((item, index) => (
          <BreadcrumbsItem
            key={item.path}
            item={item}
            position={index}
            onItemClick={onItemClick}
            displayMode={
              index === backstack.length - 1
                ? lastItemDisplayMode
                : 'link_with_chevron'
            }
          />
        ))}
      </ul>
    </>
  );
};
